import React, {FC, useEffect} from 'react';

import {StateProvider} from './context';
import {useState} from './reducer';
import {render} from './render';
import {Swipeable} from './Swipeable';
import {ScreenConfig} from './types';

import * as styles from './styles.module.scss';

interface FirstLookProps {
	screens: ScreenConfig[]
	onClose?: () => void
}

export const FirstLook: FC<FirstLookProps> = ({screens, onClose}) => {
	const [state, dispatch] = useState(onClose);
	useEffect(() => {
		if (screens.length > 0) {
			dispatch({
				type: 'SET_SCREENS',
				screens,
			});
		}
	}, [screens.length]);

	// Disable scrolling while the component is open (modal)
	useEffect(() => {
		document.body.classList.add(styles.noScroll);
		return () => {
			document.body.classList.remove(styles.noScroll);
		};
	}, []);

	const config = {state, dispatch};
	return (
		<StateProvider config={config}>
			<Swipeable>
				{(handlers) => render(config, handlers)}
			</Swipeable>
		</StateProvider>
	);
};
